import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllSubscriptions = () => {
  return Api(endPoints.getAllSubscriptions, null, requestType.GET);
};

const getAllSubscriptionsByRole = (role) => {
  return Api(
    `${endPoints.getAllSubscriptionsByRole}?role=${role}`,
    null,
    requestType.GET
  );
};

const updateSubscription = (id, params) => {
  return Api(`${endPoints.updateSubscription}/${id}`, params, requestType.PUT);
};

const getAllSubscriptionsHistoryByRole = (role, userId) => {
  return Api(
    `${endPoints.getSubscriptionHistoryByRole}?role=${role}&userId=${userId}`,
    null,
    requestType.GET
  );
};

export {
  getAllSubscriptions,
  getAllSubscriptionsByRole,
  updateSubscription,
  getAllSubscriptionsHistoryByRole,
};
